import * as l from "react";
const c = (e) => /* @__PURE__ */ l.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ l.createElement(
    "mask",
    {
      id: "KI_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ l.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ l.createElement("g", { mask: "url(#KI_svg__a)" }, /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#E31D1C"
    }
  ), /* @__PURE__ */ l.createElement(
    "mask",
    {
      id: "KI_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ l.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ l.createElement("g", { mask: "url(#KI_svg__b)" }, /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.009 9.96l.05.006c.057-.196.158-.518.288-.822.206-.482.8-.752.8-.752s-.293.331-.37.856a7.585 7.585 0 00-.07.853l.04.013a7.57 7.57 0 01.473-.718c.316-.418.958-.536.958-.536s-.365.25-.567.741a7.498 7.498 0 00-.265.78l.062.037c.142-.15.364-.373.6-.57.403-.337 1.056-.308 1.056-.308s-.413.162-.72.595a7.41 7.41 0 00-.417.67l.064.06c.172-.113.422-.268.68-.4.468-.236 1.097-.061 1.097-.061s-.438.065-.835.418c-.202.18-.391.377-.527.526l.055.082c.192-.066.454-.149.718-.209.51-.117 1.079.205 1.079.205s-.44-.043-.911.204c-.22.115-.432.246-.595.353l.048.126c.195-.02.446-.037.693-.037.524.001 1.006.443 1.006.443s-.42-.14-.934-.007c-.22.058-.437.13-.613.194.008.053.015.105.02.159.186.025.412.062.632.113.51.119.88.658.88.658s-.377-.232-.908-.217c-.21.006-.419.025-.596.046-.004.057-.01.114-.018.17.166.068.36.152.545.247.466.239.695.85.695.85s-.31-.315-.829-.429a6.736 6.736 0 00-.54-.093 3.197 3.197 0 01-.07.19c.137.098.291.213.437.336.4.338.486.986.486.986s-.232-.378-.711-.606a6.655 6.655 0 00-.472-.2 3.27 3.27 0 01-.123.184c.105.119.22.256.326.397.314.42.251 1.07.251 1.07s-.14-.42-.556-.75a6.609 6.609 0 00-.393-.286c-.054.052-.11.103-.167.152.07.136.144.29.21.444.204.483-.015 1.1-.015 1.1s-.034-.442-.358-.863a6.592 6.592 0 00-.296-.355 3.24 3.24 0 01-.214.116c.036.144.071.302.099.46.09.517-.261 1.068-.261 1.068s.066-.438-.156-.92a6.415 6.415 0 00-.204-.404c-.079.024-.16.044-.24.062.002.144 0 .302-.008.46-.029.522-.495.98-.495.98s.163-.412.056-.932a6.534 6.534 0 00-.107-.438 3.296 3.296 0 01-.241.002 6.508 6.508 0 01-.12.449c-.153.5-.717.832-.717.832s.258-.36.28-.89c.006-.156.006-.311.001-.454a3.267 3.267 0 01-.238-.057 6.454 6.454 0 01-.22.416c-.263.454-.886.65-.886.65s.332-.294.472-.805a6.57 6.57 0 00.107-.458 3.238 3.238 0 01-.212-.11 6.462 6.462 0 01-.317.367c-.358.383-1.01.434-1.01.434s.39-.211.642-.678c.08-.15.154-.305.217-.445a3.252 3.252 0 01-.164-.145 6.601 6.601 0 01-.42.298c-.44.285-1.084.177-1.084.177s.429-.11.786-.503c.122-.134.237-.274.336-.401a3.222 3.222 0 01-.12-.173 6.71 6.71 0 01-.504.208c-.493.178-1.096-.072-1.096-.072s.443-.011.88-.313c.16-.111.316-.232.447-.34a3.289 3.289 0 01-.069-.18 6.818 6.818 0 01-.575.096c-.52.063-1.052-.316-1.052-.316s.434.088.928-.107c.2-.08.395-.172.556-.254a3.36 3.36 0 01-.02-.16 6.967 6.967 0 01-.63-.046c-.52-.065-.944-.562-.944-.562s.4.191.926.12a7.08 7.08 0 00.645-.12c.005-.05.01-.099.017-.147a7.098 7.098 0 01-.649-.199c-.492-.18-.793-.76-.793-.76s.346.276.875.326c.254.024.51.028.709.027a3.21 3.21 0 01.042-.117 7.202 7.202 0 01-.626-.36c-.44-.286-.603-.919-.603-.919s.276.347.78.514c.263.088.535.154.734.197l.047-.074a7.364 7.364 0 01-.56-.534c-.356-.384-.361-1.037-.361-1.037s.183.403.631.687c.25.159.515.296.7.386l.059-.057a7.442 7.442 0 01-.448-.678c-.261-.454-.12-1.092-.12-1.092s.088.434.461.812c.221.224.464.428.624.557l.056-.034a7.538 7.538 0 01-.296-.789c-.152-.502.13-1.091.13-1.091s-.013.443.266.895c.172.28.372.543.5.703l.037-.013a7.58 7.58 0 01-.1-.862c-.027-.524.389-1.028.389-1.028s-.12.427.042.933c.1.316.232.624.317.81a3.44 3.44 0 01.048-.006c.011-.203.038-.542.096-.871.092-.516.61-.913.61-.913s-.21.389-.168.918c.027.33.086.66.127.86z",
      fill: "#FFC84A"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M-.792 13.92l2.615-1.061a1.562 1.562 0 011.188.005l3.63 1.511c.411.17.875.159 1.277-.034l2.928-1.405c.42-.202.908-.206 1.331-.01l3.068 1.417c.413.19.889.192 1.303.003l3.139-1.431c.414-.189.89-.188 1.303.003l3.099 1.43c.406.188.874.192 1.284.012l3.386-1.491a1.562 1.562 0 011.158-.04l3.036 1.091v10.014H-.88l.09-10.014z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ l.createElement(
    "mask",
    {
      id: "KI_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: -1,
      y: 12,
      width: 34,
      height: 12
    },
    /* @__PURE__ */ l.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M-.792 13.92l2.615-1.061a1.562 1.562 0 011.188.005l3.63 1.511c.411.17.875.159 1.277-.034l2.928-1.405c.42-.202.908-.206 1.331-.01l3.068 1.417c.413.19.889.192 1.303.003l3.139-1.431c.414-.189.89-.188 1.303.003l3.099 1.43c.406.188.874.192 1.284.012l3.386-1.491a1.562 1.562 0 011.158-.04l3.036 1.091v10.014H-.88l.09-10.014z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ l.createElement("g", { mask: "url(#KI_svg__c)" }, /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M-.791 16.245l2.615-1.06a1.562 1.562 0 011.188.005l3.63 1.51c.411.171.875.16 1.276-.033l2.929-1.406c.42-.201.908-.205 1.331-.01l3.068 1.418c.413.19.889.191 1.303.003l3.139-1.432c.414-.188.89-.187 1.303.003l3.099 1.43c.406.189.874.193 1.284.012l3.386-1.49a1.562 1.562 0 011.158-.041l3.036 1.091M-.791 19.575l2.615-1.062a1.562 1.562 0 011.188.006l3.63 1.51c.411.172.875.16 1.276-.033l2.929-1.406c.42-.201.908-.205 1.331-.01l3.068 1.418c.413.19.889.192 1.303.003l3.139-1.432c.414-.188.89-.187 1.303.003l3.099 1.431c.406.188.874.192 1.284.011l3.386-1.49a1.562 1.562 0 011.158-.04l3.036 1.09",
      stroke: "#015989",
      strokeWidth: 2
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M-.791 22.227l1.092-.443a5.562 5.562 0 014.228.018l2.113.88c.411.17.875.158 1.276-.034l1.23-.59a5.562 5.562 0 014.74-.035l1.358.627c.413.19.889.192 1.303.003l1.469-.67a5.562 5.562 0 014.639.01l1.433.662c.406.188.874.192 1.284.011l1.924-.847a5.562 5.562 0 014.123-.143l1.533.55v3.316H-.607l-.184-3.315z",
      fill: "#015989"
    }
  )), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.78 3.418h1.86c.468 0 1.526-.716 2.137-.477.612.239 1.641 1.01 1.641 1.01s1.7-1.342 2.713-1.342c1.014 0 2.842-.149 2.842-.149s-.429 1.113-1.635 1.302c-1.207.189-2.65 1.112-2.65 1.112h1.96c.3 0 .69.451.69.451s-.805.547-1.207.547h-.845s-.855.733-1.91.577c-1.055-.156-1.902-1.124-1.902-1.124s-.923-.132-.923-.291c0 0-.109-.05-.16-.05-.29.009-.483.06-.58.05.531-.208.74-.39.74-.39s.366-.344.644-.344c.28 0 1.21.574 1.21.574l.223-.23-1.154-.882c-2.353.247-3.695-.344-3.695-.344z",
      fill: "#FFC84A"
    }
  )))
), a = c;
export {
  a as default
};
